import type { AxiosResponse } from 'axios';
import type { GetAutoCompleteResponse } from 'api/types/autoCompleteApiTypes';

import { donedealAutoCompleteGateway } from 'api/api-utils/commonApiUtils';
import { IncomingHttpHeaders } from 'http';

async function getAutoCompleteValues(
  searchText: string,
  section?: string,
  headers: IncomingHttpHeaders = { accept: 'application/json' },
  timeout?: number,
): Promise<AxiosResponse<GetAutoCompleteResponse>> {
  const response: AxiosResponse<GetAutoCompleteResponse> =
    await donedealAutoCompleteGateway.get(
      `/v2/autocomplete?text=${searchText}${
        section ? `&section=${section}` : ''
      }`,
      {
        headers: {
          ...headers,
          accept: 'application/json',
        },
        ...(timeout && { timeout }),
      },
    );
  return response;
}

export const autoCompleteApi = { getAutoCompleteValues };
